__turbopack_context__.v({
  "activeLink": "menuItem-module-scss-module__W1ZZPW__activeLink",
  "button": "menuItem-module-scss-module__W1ZZPW__button",
  "danger": "menuItem-module-scss-module__W1ZZPW__danger",
  "disabled": "menuItem-module-scss-module__W1ZZPW__disabled",
  "icon": "menuItem-module-scss-module__W1ZZPW__icon",
  "iconWrapper": "menuItem-module-scss-module__W1ZZPW__iconWrapper",
  "link": "menuItem-module-scss-module__W1ZZPW__link",
  "spinner": "menuItem-module-scss-module__W1ZZPW__spinner",
  "success": "menuItem-module-scss-module__W1ZZPW__success",
  "text": "menuItem-module-scss-module__W1ZZPW__text",
  "tooltipContainer": "menuItem-module-scss-module__W1ZZPW__tooltipContainer",
  "tooltipWrapper": "menuItem-module-scss-module__W1ZZPW__tooltipWrapper",
});
